import { useEffect, useState } from 'react';
import { Alert, Box, Button, Chip, Stack, Tooltip, Typography } from '@mui/material';
import { paymentsApi } from '../../lib/paymentsApi';

export default function PaymentSettings() {
    const [config, setConfig] = useState(null);
    const [error, setError] = useState('');
    const [busy, setBusy] = useState(false);
    const refresh = async () => {
        try { setConfig(await paymentsApi.settings()); setError(''); }
        catch (e) { setError(e.message); }
    };
    useEffect(() => { refresh(); }, []);
    const connect = async () => {
        setBusy(true);
        try { const { url } = await paymentsApi.connect(); window.location.assign(url); }
        catch (e) { setError(e.message); setBusy(false); }
    };
    const disabled = !config?.enabled || !config?.configured || !config?.canManage || busy;
    const tooltip = !config?.enabled ? 'Contact system admin to enable' : !config?.canManage ? 'Ask your business administrator to connect Stripe' : !config?.configured ? 'Contact system admin to finish Stripe setup' : '';
    return <Box className="card" sx={{ p: 3, mb: 3, width: '100%' }}>
        <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 1 }}>
            <Typography variant="h6">Payments add-on</Typography>
            <Chip size="small" label={!config ? 'Loading...' : config.ready ? 'Connected' : config.enabled ? 'Setup needed' : 'Available add-on'} color={config?.ready ? 'success' : 'default'} />
        </Stack>
        <Typography sx={{ mb: 2 }}>Email secure payment requests from quotes. Collect deposits, track balances, and see when customers pay.</Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {config?.enabled && <Typography sx={{ mb: 2 }}>Connect your business's Stripe account, confirm your business details and payout bank account in Stripe, then return here. You never need to paste an API key into HiveQuotes.</Typography>}
        {config?.connected && !config.ready && <Alert severity="warning" sx={{ mb: 2 }}>{config.connectionIssue || 'Open the Stripe dashboard to finish your business verification, then refresh this connection.'}</Alert>}
        {config?.testMode && config?.enabled && <Alert severity="info" sx={{ mb: 2 }}>Test mode: no real money moves, and Stripe does not send invoice emails.</Alert>}
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            <Tooltip title={tooltip}><span><Button variant="contained" disabled={disabled} onClick={connect}>{config?.connected ? 'Reconnect Stripe' : 'Connect with Stripe'}</Button></span></Tooltip>
            <Button onClick={refresh}>Refresh connection</Button>
            {config?.connected && <Button href="https://dashboard.stripe.com" target="_blank" rel="noopener noreferrer">Open Stripe dashboard</Button>}
        </Stack>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>Stripe handles card entry and payment processing. Stripe processing and invoicing fees apply. Manage bank details, refunds, disputes, and automatic reminders in Stripe.</Typography>
    </Box>;
}
